export default __webpack_public_path__ + "static/quadrant-text-regular-italic-27f40e90ca3a1d529b7b93b49f77c9ae.woff2";